import api from './api';

export const listBwaImports = () =>
    api.get('/Bwa').then(r => r.data);

export const getBwaDetail = (id) =>
    api.get(`/Bwa/${id}`).then(r => r.data);

export const createBwaImport = (month, year, label) =>
    api.post('/Bwa', { month, year, label }).then(r => r.data);

export const saveBwaRows = (id, rows) =>
    api.put(`/Bwa/${id}/rows`, rows).then(r => r.data);

export const deleteBwaImport = (id) =>
    api.delete(`/Bwa/${id}`);

export const getBwaDashboard = () =>
    api.get('/Bwa/dashboard').then(r => r.data);

export const parseBwaPdf = (file) => {
    const form = new FormData();
    form.append('file', file);
    return api.post('/Bwa/parse-pdf', form, {
        headers: { 'Content-Type': 'multipart/form-data' },
    }).then(r => r.data);
};
